import { render, staticRenderFns } from "./SearchOrderID.vue?vue&type=template&id=1c51e8b7&scoped=true&"
import script from "./SearchOrderID.vue?vue&type=script&lang=ts&"
export * from "./SearchOrderID.vue?vue&type=script&lang=ts&"
import style0 from "./SearchOrderID.vue?vue&type=style&index=0&id=1c51e8b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c51e8b7",
  null
  
)

export default component.exports